const BarChartToolTip = ({ value, indexValue, color }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            background: 'white',
            padding: '5px',
            borderRadius: '3px',
        }}
    >
        <div
            style={{
                width: '10px',
                height: '10px',
                background: color,
                marginRight: '5px',
            }}
        ></div>
        <strong>{`${indexValue}: ${value}`}</strong>
    </div>

)

export default BarChartToolTip;